module.exports = __webpack_public_path__ + "static/media/youthClass.926d2482.png";